
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexvLAeq0_EafZC9UrLkM4ZKqlaUtDONrTvP5qfcX_0rPoMeta } from "/short/app/pages/index.vue?macro=true";
import { default as sydneyI0K4Nvs4htkNbSxTfOxTuO2BBDsa5_AIZ_1fAaIfBUgMeta } from "/short/app/pages/sydney.vue?macro=true";
import { default as brisbaneI6L3vi_gH9wGd7faVIKy6IRiD8yCL3NNwlXreBnATNQMeta } from "/short/app/pages/brisbane.vue?macro=true";
import { default as melbourne_LEtgtEBPQkOf_SoBReLOe5mT7Uplak_iqbxKOJKNCYMeta } from "/short/app/pages/melbourne.vue?macro=true";
import { default as indexd_gFL2fJ2Ql6d_Zxz66Z4jvD31uIkx_v5yEg83VqaxQMeta } from "/short/app/pages/press/index.vue?macro=true";
import { default as indexzlFigtvrJBkDj_5GngZX5G4VuA_xlFBZzmryT7IOEwAMeta } from "/short/app/pages/dealers/index.vue?macro=true";
import { default as index3uelhurS1Tg61xeaFDA0hI8nzvgtUMTs9Lei9wFJWsUMeta } from "/short/app/pages/sign-up/index.vue?macro=true";
import { default as indexxOIeBFStlBygd3a767bfjEFbZbIwOXfux_qFnoqqVrcMeta } from "/short/app/pages/sitemap/index.vue?macro=true";
import { default as indexf0q3X3nGUFEOy66DlTa2d2w6mujxr_Gozr4pkpwos_0Meta } from "/short/app/pages/about-us/index.vue?macro=true";
import { default as index3PuuIs9kf670O8fb0QpoAZkKlAZ0YG6Dnb5jU04LmvwMeta } from "/short/app/pages/business/index.vue?macro=true";
import { default as indexJqgXvPFUCwJ5V0c2BtFVActtw8THEvZ1HxRmRzDIkFIMeta } from "/short/app/pages/car-finance/index.vue?macro=true";
import { default as thank_45youYTnHRD_YOoEnumMEcl7XxmpRU6NiBYYtKmnoDwJWT04Meta } from "/short/app/pages/dealers/thank-you.vue?macro=true";
import { default as index75V0au56gN1AcIevJZmTaJCScFFFuFVEEK0FVHeBrKcMeta } from "/short/app/pages/sell-my-car/index.vue?macro=true";
import { default as indexy7cVbwEohCnGes_ms59pqcPbLvLC3KSCJKRTGLK3VjMMeta } from "/short/app/pages/support/app/index.vue?macro=true";
import { default as thank_45youl7WR_7XT3ZGuguNA8uKTzPfM93pv4IlapP7znIavacAMeta } from "/short/app/pages/partners/thank-you.vue?macro=true";
import { default as indexfA7aq0QiNMtgcQO_X31OhD3M_PHKoihDv7Yk1LItPWIMeta } from "/short/app/pages/secure/login/index.vue?macro=true";
import { default as indexjTOw0BJ7hvnp1p4Ijk7_h_u7BwomKrPUJITsnzCK5VsMeta } from "/short/app/pages/privacy-policy/index.vue?macro=true";
import { default as indexAc_IqINX9BGsUnQ2QgcXDNMDnssAoFfYQyrK_RXg6HQMeta } from "/short/app/pages/forgot-password/index.vue?macro=true";
import { default as thank_45youTG96kUBgQvswbvKdT79eiKQFMmtmCSuubsBUTkWbYgMMeta } from "/short/app/pages/sell-my-car/thank-you.vue?macro=true";
import { default as indexoWn_BK04YbO_mm_pFeamEJNIYQ0ZRrOoDEWtygXZolUMeta } from "/short/app/pages/about-us/careers/index.vue?macro=true";
import { default as index8IaeYc9mNcHc8q7UgQuwMy4d5ADnj5f2siJAFeApjn0Meta } from "/short/app/pages/car-subscription/index.vue?macro=true";
import { default as index5hcq8KPVZYxmmI37pmhCjd_jb2D6_3wsAZ2ThNFZl3UMeta } from "/short/app/pages/partners/lightfm/index.vue?macro=true";
import { default as _91_46_46_46slug_93XFzLjWW4FO1yNQF5eA9oz5o6f32hDa2_zSnoyw0zJiAMeta } from "/short/app/pages/cars/buy/used/[...slug].vue?macro=true";
import { default as thank_45you2_7Cp8_TAqP4vtFwCw0yPVp2CVhH6xbEPpSq0mEO5qcMeta } from "/short/app/pages/cars/buy/used/thank-you.vue?macro=true";
import { default as indexhchFy0oqEaw4dA3NB3ZP7V1YnlK3oCfLpbChQudSqpkMeta } from "/short/app/pages/electric-vehicles/index.vue?macro=true";
import { default as _91_46_46_46slug_93jUbvEHRj4Bm1Rn_C4tprisgSLINEqkvSfN5tn5Rr5UgMeta } from "/short/app/pages/cars/subscribe/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_934qWGtsSNmWKNFXcLmArKrTaSO1larmZWX5kxWCnaNhwMeta } from "/short/app/pages/reset-password/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93tgAfrzHH8xL6Cii9SnItNT_U5a2HjpXLKaj70lD5ar8Meta } from "/short/app/pages/email-validation/[...slug].vue?macro=true";
import { default as indexgkDzkCusPQM_Kc9RRqvAIN_DPcQ4Jnpk27gC4rV_5yMMeta } from "/short/app/pages/partners/sonnendrive/index.vue?macro=true";
import { default as indexjQO4Kfqdu_ztf_UkWGMiza0kbt8_Oob4igtanP0psBwMeta } from "/short/app/pages/terms-and-conditions/index.vue?macro=true";
import { default as indexxXoxvFahqUutc_DMI_s74Oq9hR22SBFAzRntHDSouzAMeta } from "/short/app/pages/partners/auroraenergy/index.vue?macro=true";
import { default as indexFOdqgySgiv7xTQQmP3DekmDDEZYtKD7kMQGxRewU3BEMeta } from "/short/app/pages/business/novated-lease/index.vue?macro=true";
import { default as indexQk2HkSSrvYCiqpUFpP8R4z1SGKkcmNxI1A2fbt0xcrQMeta } from "/short/app/pages/car-subscription/loyalty/index.vue?macro=true";
import { default as vehicle_45reserved9d_iIqFE4XZ2fieftEYQes_AKh6M6slaBIPvoSHPgQYMeta } from "/short/app/pages/cars/buy/used/vehicle-reserved.vue?macro=true";
import { default as indexaDgepxfuTVO6Tl0PRdR1BGVN41bvQY_EPxlkAzZ6n84Meta } from "/short/app/pages/business/car-subscription/index.vue?macro=true";
import { default as indexi2xFxNl7V3fcHuo3a_SeGf4YzqtjuYXm2_iup_tCpUIMeta } from "/short/app/pages/business/fleet-subscription/index.vue?macro=true";
import { default as index6ySNCatU3iMo_TnrljOAZNh2SH4uFe6682gO3Odz1FYMeta } from "/short/app/pages/partners/sonnendrive/sign-in/index.vue?macro=true";
import { default as index0MQV4_XcrhcXfICetqA22ahVnSJ0Udh7rJn90X9gtZ0Meta } from "/short/app/pages/partners/sonnendrive/sign-up/index.vue?macro=true";
import { default as thank_45you1uIpijrlWZAD31Bh2y79cPQsTc0uEPNzNZLAv_so74EMeta } from "/short/app/pages/business/car-subscription/thank-you.vue?macro=true";
import { default as indexsr_Fh2kVkruuFBV_zgE937XBGRO4IkXd82jznNbZ0T4Meta } from "/short/app/pages/business/novated-subscription/index.vue?macro=true";
import { default as indexKN7k2oX5i2Gd3TRLDd8PpPCln4VyaEnQBc_1Xndl3RYMeta } from "/short/app/pages/buying-a-car/buying-a-new-car/index.vue?macro=true";
import { default as indexptoTC1m2ffxKJNxg797NZIQ2eI_fazLamJDjIydszf0Meta } from "/short/app/pages/partners/auroraenergy/sign-in/index.vue?macro=true";
import { default as indexu3x14DBKwtGHVMx7EETej4mh7oJYYN0Wzf8FGacv1OwMeta } from "/short/app/pages/partners/auroraenergy/sign-up/index.vue?macro=true";
import { default as indexPfF5yql9pR59wTZw8D__I8UCx2rq_9k7AqeHRCxeQqAMeta } from "/short/app/pages/partners/greener-for-business/index.vue?macro=true";
import { default as indexf3XzDmuOOC1ZVLku_Y_CDb4_V29V99y1pmNJpwbZoGsMeta } from "/short/app/pages/partners/sonnendrive/about-us/index.vue?macro=true";
import { default as indexDTKGNjh5cbVO1O7nVS7tmaIjtP6w7sdZmkaMO4jDaEcMeta } from "/short/app/pages/terms-and-conditions/purchase/index.vue?macro=true";
import { default as index_UQF5LeSbbRrfACxrH0A6qJ4BWft_3YYafgJ6CLQNVcMeta } from "/short/app/pages/buying-a-car/buying-a-used-car/index.vue?macro=true";
import { default as indexHhNiKSzhwmWaTsp3CNZ3kTXKZQnnh5j7FkRbst7IFc0Meta } from "/short/app/pages/partners/auroraenergy/about-us/index.vue?macro=true";
import { default as index6LrwFu8Q1Wc1Ci8XX_S3mcz3HHJ1Ddstv9luq71vMHoMeta } from "/short/app/pages/business/novated-lease/estimate/index.vue?macro=true";
import { default as indexJEfeigbbl5MriJETTDqVxV7s9r_sYi09FjKaHSDY_P0Meta } from "/short/app/pages/car-subscription/refer-a-friend/index.vue?macro=true";
import { default as _91_46_46_46slug_93VgCMQE85P0geUN5fCfVbFqEcGCvFjr9TLvuHnMwQXvYMeta } from "/short/app/pages/partners/sonnendrive/browse/[...slug].vue?macro=true";
import { default as indexLengEoREVC_RTnV7gEap_qqgPxvu967U0RbgwKM2mfkMeta } from "/short/app/pages/business/novated-ev-subscription/index.vue?macro=true";
import { default as _91_46_46_46slug_93_BRdUfwqrw_uu3w4iMCsSn53aEh_GNDcZT_mG0wTYigMeta } from "/short/app/pages/partners/auroraenergy/browse/[...slug].vue?macro=true";
import { default as indexN4NArTx3sBdj0EMLzzlwl2pX_BJSL0T09AHXldeWnHQMeta } from "/short/app/pages/car-subscription/fees-and-charges/index.vue?macro=true";
import { default as indexGVVL9gwLW656e2KyozviKJ1GBOfUkaPiinpNftXRCIoMeta } from "/short/app/pages/partners/sonnendrive/how-it-works/index.vue?macro=true";
import { default as indexsT1JZbxR_Y0s45KtntzQTVjxtm1Ylb2DEKEjeY6I4U8Meta } from "/short/app/pages/partners/auroraenergy/how-it-works/index.vue?macro=true";
import { default as thank_45youyRKtqTOgTkhgP2oyaiEN3nYLm_EDopys0bIcE4TsAe8Meta } from "/short/app/pages/business/novated-lease/estimate/thank-you.vue?macro=true";
import { default as indexk3eZYKwhjC_MGWEALhY2wp4AKlEP5iNKv_cGFClXklEMeta } from "/short/app/pages/compare-car-subscriptions-vs-leasing/index.vue?macro=true";
import { default as indexdaFN1sHeAB7PssNRcT9ueczb6Is3s6XgS4iKx4SmPDYMeta } from "/short/app/pages/partners/sonnendrive/forgot-password/index.vue?macro=true";
import { default as indexDz12tBgpiTPCMpynWOkpa7ErLwOW7hLD5F6QdkQQDwwMeta } from "/short/app/pages/partners/auroraenergy/forgot-password/index.vue?macro=true";
import { default as indexQgjDtsGTF0bqILY_pQYaY99aNi8Z2QyY2ZEB6rM3jWEMeta } from "/short/app/pages/terms-and-conditions/car-subscription/index.vue?macro=true";
import { default as index7MFcEnj83Hfir1_rnhphR5CnmGPHRXINK7hWaNdPZacMeta } from "/short/app/pages/terms-and-conditions/carbar-concierge/index.vue?macro=true";
import { default as indexcMoPu3PgrGTrw3QmFWs1JlURKdsT6UQj5GlwKV0cyc0Meta } from "/short/app/pages/promotion/auroraenergy/get-electrified/index.vue?macro=true";
import { default as indexeFU_ixrHdyjFwzJXrd1_2OLsmRiN5mkauK8VVuxeAEAMeta } from "/short/app/pages/terms-and-conditions/carbarconnect-app/index.vue?macro=true";
import { default as indexmDZblJUplLLUZNRG4z29Dl_1LqEIsoOEy66DY7GHsdkMeta } from "/short/app/pages/terms-and-conditions/instant-valuation/index.vue?macro=true";
import { default as _91_46_46_46slug_936ciFpw7WXaXj_yw5qNQmAvnJsJc679b7B2ARypOv7RUMeta } from "/short/app/pages/partners/sonnendrive/reset-password/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93wQKVgPiDssHbLUkGhzqp4mjtPlJz92RHivOme0eCQuIMeta } from "/short/app/pages/partners/auroraenergy/reset-password/[...slug].vue?macro=true";
import { default as index_J_wzVT0ednp1B77KH2gt0OCIde5JmcGF758Znkgw00Meta } from "/short/app/pages/business/tools-of-trade/employee-benefits/index.vue?macro=true";
import { default as indexbWglO9c91mllhV6bbULVdbmVwRXNl_HuT9XPbVjEC9kMeta } from "/short/app/pages/business/fleet-subscription/small-business/index.vue?macro=true";
import { default as _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93HFW_NE529lFHmIXAFmlQ4i9LxHz7NZKJG9bviFEqt1AMeta } from "/short/app/pages/cars/buy/used/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue?macro=true";
import { default as _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93qcHyBIhmQ2ylWUBucRSK8JNOndCdaOd_vdukRg4lhlEMeta } from "/short/app/pages/cars/subscribe/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue?macro=true";
import { default as _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93EiYp5V3eysfA4N5kTmvyQRc1lF37pWvygoFmsf_5LfMMeta } from "/short/app/pages/partners/sonnendrive/browse/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue?macro=true";
import { default as _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93eVD4LFcyx1TvbgdY_TjHdxOV66BUlaeMwjYs85RUPYsMeta } from "/short/app/pages/partners/auroraenergy/browse/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue?macro=true";
import { default as component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta } from "/short/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg } from "/short/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexvLAeq0_EafZC9UrLkM4ZKqlaUtDONrTvP5qfcX_0rPoMeta || {},
    component: () => import("/short/app/pages/index.vue")
  },
  {
    name: "sydney",
    path: "/sydney",
    component: () => import("/short/app/pages/sydney.vue")
  },
  {
    name: "brisbane",
    path: "/brisbane",
    component: () => import("/short/app/pages/brisbane.vue")
  },
  {
    name: "melbourne",
    path: "/melbourne",
    component: () => import("/short/app/pages/melbourne.vue")
  },
  {
    name: "press",
    path: "/press",
    component: () => import("/short/app/pages/press/index.vue")
  },
  {
    name: "dealers",
    path: "/dealers",
    component: () => import("/short/app/pages/dealers/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index3uelhurS1Tg61xeaFDA0hI8nzvgtUMTs9Lei9wFJWsUMeta || {},
    component: () => import("/short/app/pages/sign-up/index.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/short/app/pages/sitemap/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/short/app/pages/about-us/index.vue")
  },
  {
    name: "business",
    path: "/business",
    component: () => import("/short/app/pages/business/index.vue")
  },
  {
    name: "car-finance",
    path: "/car-finance",
    component: () => import("/short/app/pages/car-finance/index.vue")
  },
  {
    name: "dealers-thank-you",
    path: "/dealers/thank-you",
    component: () => import("/short/app/pages/dealers/thank-you.vue")
  },
  {
    name: "sell-my-car",
    path: "/sell-my-car",
    component: () => import("/short/app/pages/sell-my-car/index.vue")
  },
  {
    name: "support-app",
    path: "/support/app",
    component: () => import("/short/app/pages/support/app/index.vue")
  },
  {
    name: "partners-thank-you",
    path: "/partners/thank-you",
    component: () => import("/short/app/pages/partners/thank-you.vue")
  },
  {
    name: "secure-login",
    path: "/secure/login",
    meta: indexfA7aq0QiNMtgcQO_X31OhD3M_PHKoihDv7Yk1LItPWIMeta || {},
    component: () => import("/short/app/pages/secure/login/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/short/app/pages/privacy-policy/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: indexAc_IqINX9BGsUnQ2QgcXDNMDnssAoFfYQyrK_RXg6HQMeta || {},
    component: () => import("/short/app/pages/forgot-password/index.vue")
  },
  {
    name: "sell-my-car-thank-you",
    path: "/sell-my-car/thank-you",
    component: () => import("/short/app/pages/sell-my-car/thank-you.vue")
  },
  {
    name: "about-us-careers",
    path: "/about-us/careers",
    component: () => import("/short/app/pages/about-us/careers/index.vue")
  },
  {
    name: "car-subscription",
    path: "/car-subscription",
    meta: index8IaeYc9mNcHc8q7UgQuwMy4d5ADnj5f2siJAFeApjn0Meta || {},
    component: () => import("/short/app/pages/car-subscription/index.vue")
  },
  {
    name: "partners-lightfm",
    path: "/partners/lightfm",
    component: () => import("/short/app/pages/partners/lightfm/index.vue")
  },
  {
    name: "cars-buy-used-slug",
    path: "/cars/buy/used/:slug(.*)*",
    meta: _91_46_46_46slug_93XFzLjWW4FO1yNQF5eA9oz5o6f32hDa2_zSnoyw0zJiAMeta || {},
    component: () => import("/short/app/pages/cars/buy/used/[...slug].vue")
  },
  {
    name: "cars-buy-used-thank-you",
    path: "/cars/buy/used/thank-you",
    component: () => import("/short/app/pages/cars/buy/used/thank-you.vue")
  },
  {
    name: "electric-vehicles",
    path: "/electric-vehicles",
    component: () => import("/short/app/pages/electric-vehicles/index.vue")
  },
  {
    name: "cars-subscribe-slug",
    path: "/cars/subscribe/:slug(.*)*",
    meta: _91_46_46_46slug_93jUbvEHRj4Bm1Rn_C4tprisgSLINEqkvSfN5tn5Rr5UgMeta || {},
    component: () => import("/short/app/pages/cars/subscribe/[...slug].vue")
  },
  {
    name: "reset-password-slug",
    path: "/reset-password/:slug(.*)*",
    component: () => import("/short/app/pages/reset-password/[...slug].vue")
  },
  {
    name: "email-validation-slug",
    path: "/email-validation/:slug(.*)*",
    meta: _91_46_46_46slug_93tgAfrzHH8xL6Cii9SnItNT_U5a2HjpXLKaj70lD5ar8Meta || {},
    component: () => import("/short/app/pages/email-validation/[...slug].vue")
  },
  {
    name: "partners-sonnendrive",
    path: "/partners/sonnendrive",
    meta: indexgkDzkCusPQM_Kc9RRqvAIN_DPcQ4Jnpk27gC4rV_5yMMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/short/app/pages/terms-and-conditions/index.vue")
  },
  {
    name: "partners-auroraenergy",
    path: "/partners/auroraenergy",
    meta: indexxXoxvFahqUutc_DMI_s74Oq9hR22SBFAzRntHDSouzAMeta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/index.vue")
  },
  {
    name: "business-novated-lease",
    path: "/business/novated-lease",
    component: () => import("/short/app/pages/business/novated-lease/index.vue")
  },
  {
    name: "car-subscription-loyalty",
    path: "/car-subscription/loyalty",
    component: () => import("/short/app/pages/car-subscription/loyalty/index.vue")
  },
  {
    name: "cars-buy-used-vehicle-reserved",
    path: "/cars/buy/used/vehicle-reserved",
    component: () => import("/short/app/pages/cars/buy/used/vehicle-reserved.vue")
  },
  {
    name: "business-car-subscription",
    path: "/business/car-subscription",
    component: () => import("/short/app/pages/business/car-subscription/index.vue")
  },
  {
    name: "business-fleet-subscription",
    path: "/business/fleet-subscription",
    component: () => import("/short/app/pages/business/fleet-subscription/index.vue")
  },
  {
    name: "partners-sonnendrive-sign-in",
    path: "/partners/sonnendrive/sign-in",
    meta: index6ySNCatU3iMo_TnrljOAZNh2SH4uFe6682gO3Odz1FYMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/sign-in/index.vue")
  },
  {
    name: "partners-sonnendrive-sign-up",
    path: "/partners/sonnendrive/sign-up",
    meta: index0MQV4_XcrhcXfICetqA22ahVnSJ0Udh7rJn90X9gtZ0Meta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/sign-up/index.vue")
  },
  {
    name: "business-car-subscription-thank-you",
    path: "/business/car-subscription/thank-you",
    component: () => import("/short/app/pages/business/car-subscription/thank-you.vue")
  },
  {
    name: "business-novated-subscription",
    path: "/business/novated-subscription",
    component: () => import("/short/app/pages/business/novated-subscription/index.vue")
  },
  {
    name: "buying-a-car-buying-a-new-car",
    path: "/buying-a-car/buying-a-new-car",
    meta: indexKN7k2oX5i2Gd3TRLDd8PpPCln4VyaEnQBc_1Xndl3RYMeta || {},
    component: () => import("/short/app/pages/buying-a-car/buying-a-new-car/index.vue")
  },
  {
    name: "partners-auroraenergy-sign-in",
    path: "/partners/auroraenergy/sign-in",
    meta: indexptoTC1m2ffxKJNxg797NZIQ2eI_fazLamJDjIydszf0Meta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/sign-in/index.vue")
  },
  {
    name: "partners-auroraenergy-sign-up",
    path: "/partners/auroraenergy/sign-up",
    meta: indexu3x14DBKwtGHVMx7EETej4mh7oJYYN0Wzf8FGacv1OwMeta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/sign-up/index.vue")
  },
  {
    name: "partners-greener-for-business",
    path: "/partners/greener-for-business",
    component: () => import("/short/app/pages/partners/greener-for-business/index.vue")
  },
  {
    name: "partners-sonnendrive-about-us",
    path: "/partners/sonnendrive/about-us",
    meta: indexf3XzDmuOOC1ZVLku_Y_CDb4_V29V99y1pmNJpwbZoGsMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/about-us/index.vue")
  },
  {
    name: "terms-and-conditions-purchase",
    path: "/terms-and-conditions/purchase",
    component: () => import("/short/app/pages/terms-and-conditions/purchase/index.vue")
  },
  {
    name: "buying-a-car-buying-a-used-car",
    path: "/buying-a-car/buying-a-used-car",
    meta: index_UQF5LeSbbRrfACxrH0A6qJ4BWft_3YYafgJ6CLQNVcMeta || {},
    component: () => import("/short/app/pages/buying-a-car/buying-a-used-car/index.vue")
  },
  {
    name: "partners-auroraenergy-about-us",
    path: "/partners/auroraenergy/about-us",
    meta: indexHhNiKSzhwmWaTsp3CNZ3kTXKZQnnh5j7FkRbst7IFc0Meta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/about-us/index.vue")
  },
  {
    name: "business-novated-lease-estimate",
    path: "/business/novated-lease/estimate",
    component: () => import("/short/app/pages/business/novated-lease/estimate/index.vue")
  },
  {
    name: "car-subscription-refer-a-friend",
    path: "/car-subscription/refer-a-friend",
    component: () => import("/short/app/pages/car-subscription/refer-a-friend/index.vue")
  },
  {
    name: "partners-sonnendrive-browse-slug",
    path: "/partners/sonnendrive/browse/:slug(.*)*",
    meta: _91_46_46_46slug_93VgCMQE85P0geUN5fCfVbFqEcGCvFjr9TLvuHnMwQXvYMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/browse/[...slug].vue")
  },
  {
    name: "business-novated-ev-subscription",
    path: "/business/novated-ev-subscription",
    component: () => import("/short/app/pages/business/novated-ev-subscription/index.vue")
  },
  {
    name: "partners-auroraenergy-browse-slug",
    path: "/partners/auroraenergy/browse/:slug(.*)*",
    meta: _91_46_46_46slug_93_BRdUfwqrw_uu3w4iMCsSn53aEh_GNDcZT_mG0wTYigMeta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/browse/[...slug].vue")
  },
  {
    name: "car-subscription-fees-and-charges",
    path: "/car-subscription/fees-and-charges",
    component: () => import("/short/app/pages/car-subscription/fees-and-charges/index.vue")
  },
  {
    name: "partners-sonnendrive-how-it-works",
    path: "/partners/sonnendrive/how-it-works",
    meta: indexGVVL9gwLW656e2KyozviKJ1GBOfUkaPiinpNftXRCIoMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/how-it-works/index.vue")
  },
  {
    name: "partners-auroraenergy-how-it-works",
    path: "/partners/auroraenergy/how-it-works",
    meta: indexsT1JZbxR_Y0s45KtntzQTVjxtm1Ylb2DEKEjeY6I4U8Meta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/how-it-works/index.vue")
  },
  {
    name: "business-novated-lease-estimate-thank-you",
    path: "/business/novated-lease/estimate/thank-you",
    component: () => import("/short/app/pages/business/novated-lease/estimate/thank-you.vue")
  },
  {
    name: "compare-car-subscriptions-vs-leasing",
    path: "/compare-car-subscriptions-vs-leasing",
    component: () => import("/short/app/pages/compare-car-subscriptions-vs-leasing/index.vue")
  },
  {
    name: "partners-sonnendrive-forgot-password",
    path: "/partners/sonnendrive/forgot-password",
    meta: indexdaFN1sHeAB7PssNRcT9ueczb6Is3s6XgS4iKx4SmPDYMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/forgot-password/index.vue")
  },
  {
    name: "partners-auroraenergy-forgot-password",
    path: "/partners/auroraenergy/forgot-password",
    meta: indexDz12tBgpiTPCMpynWOkpa7ErLwOW7hLD5F6QdkQQDwwMeta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/forgot-password/index.vue")
  },
  {
    name: "terms-and-conditions-car-subscription",
    path: "/terms-and-conditions/car-subscription",
    component: () => import("/short/app/pages/terms-and-conditions/car-subscription/index.vue")
  },
  {
    name: "terms-and-conditions-carbar-concierge",
    path: "/terms-and-conditions/carbar-concierge",
    component: () => import("/short/app/pages/terms-and-conditions/carbar-concierge/index.vue")
  },
  {
    name: "promotion-auroraenergy-get-electrified",
    path: "/promotion/auroraenergy/get-electrified",
    meta: indexcMoPu3PgrGTrw3QmFWs1JlURKdsT6UQj5GlwKV0cyc0Meta || {},
    component: () => import("/short/app/pages/promotion/auroraenergy/get-electrified/index.vue")
  },
  {
    name: "terms-and-conditions-carbarconnect-app",
    path: "/terms-and-conditions/carbarconnect-app",
    component: () => import("/short/app/pages/terms-and-conditions/carbarconnect-app/index.vue")
  },
  {
    name: "terms-and-conditions-instant-valuation",
    path: "/terms-and-conditions/instant-valuation",
    component: () => import("/short/app/pages/terms-and-conditions/instant-valuation/index.vue")
  },
  {
    name: "partners-sonnendrive-reset-password-slug",
    path: "/partners/sonnendrive/reset-password/:slug(.*)*",
    meta: _91_46_46_46slug_936ciFpw7WXaXj_yw5qNQmAvnJsJc679b7B2ARypOv7RUMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/reset-password/[...slug].vue")
  },
  {
    name: "partners-auroraenergy-reset-password-slug",
    path: "/partners/auroraenergy/reset-password/:slug(.*)*",
    meta: _91_46_46_46slug_93wQKVgPiDssHbLUkGhzqp4mjtPlJz92RHivOme0eCQuIMeta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/reset-password/[...slug].vue")
  },
  {
    name: "business-tools-of-trade-employee-benefits",
    path: "/business/tools-of-trade/employee-benefits",
    component: () => import("/short/app/pages/business/tools-of-trade/employee-benefits/index.vue")
  },
  {
    name: "business-fleet-subscription-small-business",
    path: "/business/fleet-subscription/small-business",
    component: () => import("/short/app/pages/business/fleet-subscription/small-business/index.vue")
  },
  {
    name: "cars-buy-used-make-model-year-body_type-webref_code-stock_id",
    path: "/cars/buy/used/:make()/:model()/:year()-:body_type()-:webref_code()-:stock_id()",
    meta: _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93HFW_NE529lFHmIXAFmlQ4i9LxHz7NZKJG9bviFEqt1AMeta || {},
    component: () => import("/short/app/pages/cars/buy/used/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue")
  },
  {
    name: "cars-subscribe-make-model-year-body_type-webref_code-stock_id",
    path: "/cars/subscribe/:make()/:model()/:year()-:body_type()-:webref_code()-:stock_id()",
    meta: _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93qcHyBIhmQ2ylWUBucRSK8JNOndCdaOd_vdukRg4lhlEMeta || {},
    component: () => import("/short/app/pages/cars/subscribe/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue")
  },
  {
    name: "partners-sonnendrive-browse-make-model-year-body_type-webref_code-stock_id",
    path: "/partners/sonnendrive/browse/:make()/:model()/:year()-:body_type()-:webref_code()-:stock_id()",
    meta: _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93EiYp5V3eysfA4N5kTmvyQRc1lF37pWvygoFmsf_5LfMMeta || {},
    component: () => import("/short/app/pages/partners/sonnendrive/browse/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue")
  },
  {
    name: "partners-auroraenergy-browse-make-model-year-body_type-webref_code-stock_id",
    path: "/partners/auroraenergy/browse/:make()/:model()/:year()-:body_type()-:webref_code()-:stock_id()",
    meta: _91year_93_45_91body_type_93_45_91webref_code_93_45_91stock_id_93eVD4LFcyx1TvbgdY_TjHdxOV66BUlaeMwjYs85RUPYsMeta || {},
    component: () => import("/short/app/pages/partners/auroraenergy/browse/[make]/[model]/[year]-[body_type]-[webref_code]-[stock_id].vue")
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business-car-subscription/employee",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business-car-subscription",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business-car-subscription/small",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business-car-subscription/small-business",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business-car-subscription/tools-of-trade",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business-car-subscription/corporate",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/employee-benefits/salary-sacrifice",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/employee-benefits/novated-ev-subscription",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/employee-benefits/terms-and-conditions/car-subscription",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/fleet-vehicle-subscription",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/novated",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/tools-of-trade",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/small-business",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/business/fleet/vehicle-subscription",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/privacy",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/car-subscription-electric",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/subscription-vs-leasing",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/partners",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/cars/buy/used/:pathMatch(.*)",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  },
  {
    name: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0ggMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubdJBMDuhGL0HnwKtYXLC0dEOpF5CDQ2CU7NMze_ea0gg
  }
]